@import "../../scss/reset.css";
@import url("https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap");

:host {
  --color-primary-accent: #ea4c78;
  --color-primary-warm: #ef7d61;

  --color-secondary-green: #9fce98;
  --color-secondary-cyan: #3fb7ab;
  --color-secondary-blue: #8ecfd3;
  --color-secondary-green-light: #afcb3a;
  --color-secondary-yellow: #f6e94a;

  --color-basic-background-dark: #191d36;
  --color-basic-background-light: #111831;
  --color-basic-text: #e3e3e5;
  --color-basic-label: #8b8ea9;
  --color-basic-border: #30374e;

  --color-status-info: #61a4e4;
  --color-status-success: #329e4a;
  --color-status-warning: #f8ad3f;
  --color-status-danger: #d13f45;

  --color-site-type-streetwork: #f8ad3f;
  --color-site-type-rooftop: #ed6b6c;
  --color-site-type-greenfield: #7499d0;
  --color-dark-500: #616fb5;
  --color-dark-bg: #0c1027;

  display: block;
  height: 100%;
  width: 100%;
  box-sizing: content-box;
  position: relative;
  min-width: 725px;
  min-height: 700px;

  font-family: "Rubik", "Barlow", sans-serif;
}

:host[hidden] {
  display: none;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

contact-form {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(22 0 0 / 60%);
  animation: fadeIn 0.5s linear;
}

#logo {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 3;
}

.hidden {
  display: none;
}
